<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        ><v-toolbar-title>THÊM MÔN HỌC CHÍNH KHÓA</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <SubjectNewForm ref="form" :state="dialog" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="gray--text" depressed outlined @click="cancel">HUỶ</v-btn>
        <v-btn depressed color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SubjectNewForm from '@/components/basic/form/SubjectNewForm'
import { mapActions } from 'vuex'
import { chunk, get } from 'lodash'
import { Class, Teaching, Subject } from '@/plugins/api'

export default {
  components: {
    SubjectNewForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('subjects', ['createSubject']),
    async save() {
      let subject = {}
      try {
        const data = this.$refs.form.getData()
        if (!data) return
        this.$loading.active = true
        const subjects = await Subject.fetch({
          title: data.title,
          _limit: 1
        })
        if (subjects && subjects.length) {
          //  môn trùng tên
          this.$alert.error('Môn này đã tồn tại!')
          return
        }

        subject = await this.createSubject({ ...data })
        const classes = await Class.fetch({
          division: subject.division.id,
          grade: data.grade,
          _limit: -1
        })

        const sgIndex = `00${subject.subjectGroup && subject.subjectGroup.index}`.substr(
          `00${subject.subjectGroup && subject.subjectGroup.index}`.length - 2
        )
        const groups = chunk(classes, 5)
        for (let subClasses of groups) {
          await Promise.all(
            subClasses.map(async c => {
              const grade = `00${c.grade.gradeNumber}`.substr(`00${c.grade.gradeNumber}`.length - 2)
              const tags = grade + c.title + sgIndex

              await Teaching.create({
                class: c.id,
                grade: c.grade.id,
                subject: subject.id,
                subjectGroup: get(subject.subjectGroup, 'id'),
                tags
              })
            })
          )
        }

        this.$alert.addSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.addError()
        await Subject.remove(get(subject, 'id'))
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
